import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { XIcon } from '../../../assets/icons';
import {
  ModalActions,
  ModalCloseButton,
  ModalContainer,
  ModalHeader,
  ModalContent,
  ModalContentContainer,
  ModalFooter,
  StyledModal,
} from './css';

/**
 * Creates a modal alert popup (take a look into SystemError component for example)
 *
 * @param Header - header {Component}
 * @param Content - alert content/body
 * @param Actions - alert actions {Component}
 * @param isOpen - is modal opened {boolean}
 * @param onClose - close callback {function}
 * @param isCloseButton - is close button is presented {boolean}
 * @returns {Component}
 */
const AlertModal = ({
  header: Header,
  content: Content,
  actions: Actions,
  footer: Footer,
  isOpen,
  onClose,
  isCloseButton = true,
  shrinkwrapContent = false,
  maximizeZIndex = false,
  headerIsVisible,
}) => {
  /*
    Quick fix for the scrolling issue.
    TODO: when we have time we need to investigate the root cause and then remove this code.
    Some info: Issue is related to modal appearance/closing. documentElement.scrollTop is changed.
   */
  const pos = useRef(0);
  if (typeof document !== 'undefined') { pos.current = document.documentElement.scrollTop; }

  useEffect(() => () => setTimeout(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo(0, pos.current);
    }
  }, 0), [isOpen]);
  // till this point

  const pageHeader = (typeof document !== 'undefined') ? document.getElementsByTagName('Header') : null;
  const pageHeaderHeight = (pageHeader && pageHeader.length > 0) ? pageHeader[0].clientHeight : 0;
  const margin = (headerIsVisible) ? `${pageHeaderHeight}px` : 0;

  return (
    <StyledModal
      isOpen={isOpen}
      shrinkwrapContent={shrinkwrapContent}
      maximizeZIndex={maximizeZIndex}
      marginTop={margin}
    >
      <ModalContainer>
        {isCloseButton && (
          <ModalCloseButton onClick={onClose}>
            <XIcon />
          </ModalCloseButton>
        )}
        <ModalContentContainer>
          <ModalHeader>
            <Header />
          </ModalHeader>
          <ModalContent>
            <Content />
          </ModalContent>
          {Actions && (
          <ModalActions>
            <Actions />
          </ModalActions>
          )}
          {Footer && (
          <ModalFooter>
            <Footer />
          </ModalFooter>
          )}
        </ModalContentContainer>
      </ModalContainer>
    </StyledModal>
  );
};

AlertModal.propTypes = {
  header: PropTypes.elementType,
  content: PropTypes.elementType,
  actions: PropTypes.elementType,
  footer: PropTypes.elementType,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isCloseButton: PropTypes.bool,
  shrinkwrapContent: PropTypes.bool,
  maximizeZIndex: PropTypes.bool,
  headerIsVisible: PropTypes.bool,
};

export default AlertModal;
